var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "VPopup",
    {
      ref: "popup",
      staticClass: "custom-navbar-settings",
      attrs: { fixed: "", lazy: false, "trigger-element": _vm.triggerElement },
      model: {
        value: _vm.open,
        callback: function ($$v) {
          _vm.open = $$v
        },
        expression: "open",
      },
    },
    [
      _c(
        "div",
        { staticClass: "navbar-settings-header" },
        [
          _c("VIcon", {
            staticClass: "title-icon",
            attrs: { icon: "mdi-sort", size: 24 },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [_vm._v("顶栏布局设置")]),
          _vm._v(" "),
          _c("div", { staticClass: "grow" }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "close",
              on: {
                click: function ($event) {
                  _vm.open = false
                },
              },
            },
            [_c("VIcon", { attrs: { icon: "close", size: 18 } })],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "navbar-settings-content" }, [
        _c("div", { staticClass: "navbar-settings-section" }, [
          _c("div", { staticClass: "navbar-settings-section-title" }, [
            _vm._v("边缘间距"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "navbar-settings-section-description" }, [
            _vm._v(
              "\n        设定两侧边缘处的间距, 单位为百分比, 100%为整个顶栏的宽度.\n        "
            ),
            _c("br"),
            _vm._v("空间不足时, 实际呈现的间距会自动缩小.\n      "),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "navbar-settings-section-content",
              on: {
                mouseover: function ($event) {
                  return _vm.peekPadding(true)
                },
                mouseout: function ($event) {
                  return _vm.peekPadding(false)
                },
              },
            },
            [
              _c("VSlider", {
                attrs: { min: 0, max: 40, step: 0.5 },
                model: {
                  value: _vm.padding,
                  callback: function ($$v) {
                    _vm.padding = $$v
                  },
                  expression: "padding",
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "padding-value" }, [
                _vm._v(_vm._s(_vm.padding.toFixed(1)) + "%"),
              ]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm.isLogin
          ? _c(
              "div",
              { staticClass: "navbar-settings-section" },
              [
                _c("div", { staticClass: "navbar-settings-section-title" }, [
                  _vm._v("元素呈现"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "navbar-settings-section-description" },
                  [
                    _vm._v(
                      "\n        按住并拖动可以调整顺序, 点击眼睛图标可以切换隐藏/显示.\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                !_vm.loaded ? _c("VLoading") : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.loaded,
                        expression: "loaded",
                      },
                    ],
                    ref: "navbarSortList",
                    staticClass:
                      "navbar-settings-section-content navbar-sort-list",
                  },
                  _vm._l(_vm.rendered.items, function (item) {
                    return _c(
                      "div",
                      {
                        key: item.name,
                        staticClass: "navbar-sort-item",
                        class: { "navbar-hidden": item.hidden },
                        attrs: { "data-name": item.name },
                        on: {
                          mouseover: function ($event) {
                            return _vm.peekItem(item, true)
                          },
                          mouseout: function ($event) {
                            return _vm.peekItem(item, false)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "item-name" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.displayName) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "toggle-visible" },
                          [
                            _c("VIcon", {
                              attrs: {
                                size: 18,
                                icon: item.hidden
                                  ? "mdi-eye-off-outline"
                                  : "mdi-eye-outline",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleVisible(item)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }